var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import { Row, Col } from "@riseart/antd-provider";
import { Heading, Link } from "@riseart/common";
import { splitName } from "@riseart/fe-utils";
import { ArtistListCardCls, ArtistListCardDetailsCls, ArtistListCardArtsCls } from "./Card.less";
var ArtistListCard = /* @__PURE__ */ __name(function ArtistListCard2(_ref) {
  var titleTag = _ref.titleTag, name = _ref.name, url = _ref.url, _ref$infoList = _ref.infoList, infoList = _ref$infoList === void 0 ? null : _ref$infoList, children = _ref.children, isMobile = _ref.isMobile;
  var _splitName = splitName(name), firstName = _splitName.firstName, lastName = _splitName.lastName;
  return /* @__PURE__ */ React.createElement(Row, {
    type: "flex",
    justify: "space-between",
    gutter: 16,
    className: ArtistListCardCls
  }, /* @__PURE__ */ React.createElement(Col, {
    span: 24,
    sm: 7
  }, /* @__PURE__ */ React.createElement(Heading, {
    tag: titleTag || "h3",
    level: isMobile ? "3" : "2",
    artistListItemDetailsCls: true
  }, url ? /* @__PURE__ */ React.createElement(Link, {
    to: url,
    title: name
  }, firstName && /* @__PURE__ */ React.createElement("span", null, firstName, " ") || null, lastName && /* @__PURE__ */ React.createElement("span", null, lastName) || null) : /* @__PURE__ */ React.createElement(React.Fragment, null, firstName && /* @__PURE__ */ React.createElement("span", null, firstName, " ") || null, lastName && /* @__PURE__ */ React.createElement("span", null, lastName) || null)), Array.isArray(infoList) ? infoList.map(function(info, key) {
    return /* @__PURE__ */ React.createElement("div", {
      key,
      className: ArtistListCardDetailsCls
    }, info);
  }) : null), children && /* @__PURE__ */ React.createElement(Col, {
    span: 24,
    sm: 17,
    className: ArtistListCardArtsCls
  }, children) || null);
}, "ArtistListCard");
export {
  ArtistListCard
};
